import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TOPBAR_PHONE_HREF } from '../../core/constants/basel';

const MAP_EMBED =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.3317738537926!2d-80.4083137239043!3d25.79262640732524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9bef491b7e0d1%3A0x171535882ccc986d!2s1970%20NW%20129th%20Ave%20STE%20105%2C%20Miami%2C%20FL%2033182!5e0!3m2!1sen!2sus!4v1708436680767!5m2!1sen!2sus';

@Component({
  selector: 'app-contact',
  imports: [FormsModule],
  templateUrl: './contact.component.html'
})
export class ContactComponent {
  readonly phone = '305-599-8282';
  readonly phoneHref = TOPBAR_PHONE_HREF;
  readonly email = 'diffuserdreams@gmail.com';
  readonly mapSrc: SafeResourceUrl;

  name = '';
  emailValue = '';
  subject = '';
  message = '';
  readonly sent = signal(false);
  readonly error = signal('');

  constructor(sanitizer: DomSanitizer) {
    this.mapSrc = sanitizer.bypassSecurityTrustResourceUrl(MAP_EMBED);
  }

  submit(event: Event): void {
    event.preventDefault();
    this.error.set('');
    if (!this.name.trim() || !this.emailValue.trim()) {
      this.error.set('Please fill in the required fields.');
      return;
    }
    this.sent.set(true);
  }
}
